module.exports = __webpack_public_path__ + "static/media/phone_icon.b73ed114.svg";